var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-logout.c609e950.png","uri@3x": __webpack_public_path__ + "icon-logout.78dcd3fe.png","uri@2x": __webpack_public_path__ + "icon-logout.514d5e63.png",
    width: 10,
    height: 12
});